import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderTitle } from '../../../components/molecues';

class VideoWebinarArchive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 9,
            src: null,
           
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickHome = () => {
        this.props.history.replace('/WebinarArchive');
    }
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
            
        };
        const fileName = "https://ecprime-web.s3.ap-northeast-1.amazonaws.com/video/webinararchive/" + this.props.acvFileName;
        return(
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <video 
                    width="100%"
                    height="100%"
                    autoPlay 
                    controls 
                    controlsList="nodownload"
                    disablePictureInPicture 
                    onContextMenu={e=> e.preventDefault()}
                >
                    <source src={fileName} type="video/mp4" />                    
                </video>
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {  
        acvFileName: store.video.acvFileName,
    }
};

const connectedVideoWebinarArchive = connect(mapStateToProps)(VideoWebinarArchive);
export { connectedVideoWebinarArchive as VideoWebinarArchive };

const Body = styled.div`
    video {
        user-select: none;
        max-width: 1024px;
        text-align: center;
        display: block;
        margin: auto;
    }
`;